import { useAirModal } from '@air/provider-modal';

import { AddToCanvasModal } from '~/components/Modals/AddToCanvasModal/AddToCanvasModal';

export const useAddToCanvasModal = () => {
  const [showAddToCanvasModal] = useAirModal(AddToCanvasModal);

  return { showAddToCanvasModal };
};
